import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { AuthService } from '@gan/common/feature-auth';
import { LanguageComponent } from '@gan/core/feature-language';
import { ApplicationVersionService } from '@gan/core/feature-application-version';
import { SpinnerComponent } from '@gan/common/ui-spinner';
import { NotificationComponent } from '@gan/common/ui-notification';
import { AddToHomeScreenComponent } from '@gan/core/feature-add-to-home-screen';

@Component({
  selector: 'gan-staff',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SpinnerComponent, NotificationComponent, AddToHomeScreenComponent, RouterOutlet, AsyncPipe],
})
export class AppComponent extends LanguageComponent {
  private applicationVersionService = inject(ApplicationVersionService);
  private authService = inject(AuthService);

  readonly msAccount$ = this.authService.msAccount$;

  constructor() {
    super();

    this.applicationVersionService.init();
  }
}
